// extracted by mini-css-extract-plugin
export var aiStarIcon = "_iz-2";
export var container = "_iz-4";
export var dismissButton = "_iz-3";
export var hasPaddingBottom = "_iz-6";
export var last = "_iz-e";
export var scrollbarThumb = "_iz-c";
export var scrollbarTrack = "_iz-b";
export var selected = "_iz-9";
export var spin = "_iz-1";
export var spinning = "_iz-0";
export var suggestionItem = "_iz-d";
export var suggestionsPanel = "_iz-5";
export var tonePill = "_iz-8";
export var tonesContainer = "_iz-7";
export var unselected = "_iz-a";